var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a-layout',[_c('a-layout-content',[_c('nav',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/customizer"}},[_vm._v("Customizer")])],1),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }